export class Constants {
  // GRAPH API URL's
  static GRAPH_BASE_URL = "https://graph.microsoft.com/v1.0/users/";

  static GRAPH_BASE_URL_LIST = "https://graph.microsoft.com/v1.0/sites/";

  static url = window.location.origin;

  static HSE_BASE_URL = Constants.url.includes("localhost")
    ? "https://hseglobal-qa.azurewebsites.net//api"
    : window.location.origin + "/api";

  static GRAPH_USER_QUERY =
    "?$Select=displayname,userPrincipalName, extension_8b4e685f580748b59864d62c2e7fcfad_employeeType," +
    "givenName, surname," +
    "jobTitle,extension_8b4e685f580748b59864d62c2e7fcfad_employeeNumber," +
    "extension_8b4e685f580748b59864d62c2e7fcfad_msDS_cloudExtensionAttribute10," +
    "extension_8b4e685f580748b59864d62c2e7fcfad_msDS_cloudExtensionAttribute6, " +
    "extension_8b4e685f580748b59864d62c2e7fcfad_sAMAccountName";

  static GRAPH_MANAGER_QUERY =
    "?$Select=displayName,userPrincipalName," +
    "jobTitle,extension_8b4e685f580748b59864d62c2e7fcfad_employeeNumber," +
    "extension_8b4e685f580748b59864d62c2e7fcfad_sAMAccountName";

  static GRAPH_PHOTO_QUERY = "/photos/120x120/$value";

  // {site-id}/lists/{list-id}/items?expand=fields(select=Column1,Column2)
  static SHAREPOINT_LIST =
    "49766de1-5108-44c4-93cb-2f9a9586c0fe/lists/3ac15fff-ad48-4e31-9bf0-c4fd3a319746/items?expand=fields";

  // HSE API URL's

  static GET_MAP_URL = Constants.HSE_BASE_URL + "/maps/1";

  
  static POST_USER_DETAILS = Constants.HSE_BASE_URL + "/user/add";

  static POST_CHECK_IN = Constants.HSE_BASE_URL + "/checkin";

  static POST_CHECK_OUT = Constants.HSE_BASE_URL + "/checkin/update";

  static GET_USER_DETAILS = Constants.HSE_BASE_URL + "/user/details";

  static GET_FACILITIES = Constants.HSE_BASE_URL + "/facility";

  static getUserDetails= Constants.HSE_BASE_URL +"/user/getuserdetails?userName="
  static GET_FACILITIES_COORDINATES =
    Constants.HSE_BASE_URL + "/facility/geofence";

  static POST_COMPLAINCE = Constants.HSE_BASE_URL + "/compliances/search";

  static PROXY_GROUP = Constants.HSE_BASE_URL + "/proxygroup";

  static POST_COMPUTE_STATUS =
    Constants.HSE_BASE_URL + "/compliances/computestatus";

  static GET_CITY_SEARCH = Constants.HSE_BASE_URL + "/cities/";

  static GET_HISTORY = Constants.HSE_BASE_URL + "/checkin/history";

  // External login API's

  static FORGOT_PASSWORD = Constants.HSE_BASE_URL + "/user/forgotpassword";

  static CHANGE_PASSWORD = Constants.HSE_BASE_URL + "/user/changepassword";

  static LOGIN_EXTERNAL = Constants.HSE_BASE_URL + "/user/login";

  static REGISTER_USER = Constants.HSE_BASE_URL + "/user/register";

  static TOKEN_VALIDATION = Constants.HSE_BASE_URL + "/user/validatetoken";

  static RESEND_LINK = Constants.HSE_BASE_URL + "/user/resendlink";

  static RESET_PASSWORD = Constants.HSE_BASE_URL + "/user/setpassword";

  static SEARCH_EXTERNAL_USERS =
    Constants.HSE_BASE_URL + "/user/external?searchString=";

  static INVITE_EXTERNAL_USERS = Constants.HSE_BASE_URL + "/user/invite";

  static VALIDATE_EXTERNAL_REGISTRATION_TOKEN =
    Constants.HSE_BASE_URL + "/user/validateregistrationtoken";

  static HR_API_DETAILS = Constants.HSE_BASE_URL + "/user/hrdetails";

  static USER_PERMISSION_MAPPING = Constants.HSE_BASE_URL + "/user/permissions";

  static USER_PERMISSION_MAPPING_FACILTIES =
    Constants.HSE_BASE_URL + "/user/permissionfacilities/";

  // Error
  static USER_IS_NOT_VALID = "User is not valid";

  static POST_TEMPLATE = Constants.HSE_BASE_URL + "/compliances";

  static GET_RECENT_TWO = Constants.HSE_BASE_URL + "/checkin/recent";

  static GET_ACTIVE_CHECKINS = Constants.HSE_BASE_URL + "/checkin/active";

  static POST_PERMISSIONS = Constants.HSE_BASE_URL + "/permission";

  static GET_PERMISSIONS = Constants.HSE_BASE_URL + "/permission/users";

  static GET_SUPER_ADMIN_PERMISSIONS =
    Constants.HSE_BASE_URL + "/permission/admins";

  static GET_SUPER_ADMIN_PERMISSIONS_FACILTIES =
    Constants.HSE_BASE_URL + "/permission/facilities";

  static GET_SUPER_ADMIN_USERS =
    Constants.HSE_BASE_URL + "/permission/superadmins";

  static GET_ADMIN_COMPLIANCE_IMAGE = Constants.HSE_BASE_URL + "/compliances/";

  static GET_RISK_CALCULATIONS =
    Constants.HSE_BASE_URL + "/facility/risklevel?facilityId=";

  static POST_LANGUAGE_DETAILS =
    Constants.HSE_BASE_URL + "/user/setlanguage/?language=";

  static GET_FACILITIES_ADMIN_CONFIGURATION =
    Constants.HSE_BASE_URL + "/facility/all";

  static POST_FACILITIES_ADMIN_CONFIGURATION =
    Constants.HSE_BASE_URL + "/facility";

  static GET_APPROVED_REQUEST_FOR_FACILITY =
    Constants.HSE_BASE_URL + "/siterequests/facility/";

  static GET_DYNAMIC_QR_CODE_FOR_USER_FLOW =
    Constants.HSE_BASE_URL + "/siterequests/qrcode";

  static POST_SITE_REQUEST_DETAILS = Constants.HSE_BASE_URL + "/siterequests";

  static UPDATE_SITE_REQUEST_DETAILS =
    Constants.HSE_BASE_URL + "/siterequests/updatestatus";

  static GET_SITE_REQUEST_QRCODE_CREWDETAILS =
    Constants.HSE_BASE_URL + "/siterequests/proxyqr?";

  static GET_EVACUATION_COUNTRY_DATA =
    Constants.HSE_BASE_URL + "/maps/countryevacuationlist";

  static GET_FILE =
    Constants.HSE_BASE_URL + "/files/getfile"
}

export const LoginType = {
  No_User: "No User",
  Internal_User: "Internal User",
  External_User: "External User",
};

export const WORKING_STATUS = {
  Staff_House: "Staff House",
  Working_On_Site: "Working On Site",
  Work_From_Home: "Teleworking",
  Training: "Training",
  On_Business_Trip: "On Business Trip",
  Quarantined: "Quarantined",
  Self_Isolation: "Self Isolation",
  On_Leave: "Vacation",
  Personal_Travel: "Personal Travel (Optional)",
  Not_working: "Not Working",
};

export const COMPLIAN_TYPE = {
  No_Selection: "select_readiness_status",
  Compliant: "ready",
  Non_Compliant: "not_ready",
  Partial_Compliant: "medium",
};

export const AssessmentResultType = {
  None: 0,
  Green: 1,
  Yellow: 2,
  Red: 3,
};

export const ManagerFeedback = {
  No_Feedback: "No_Feedback",
  Continue_To_Work: "Continue to work",
  Suggested_Quarantine: "Suggested Quarantine",
  Suggested_Self_Isolation: "Suggested Self Isolation",
};

export const ModelState = {
  Added: 1,
  Modified: 2,
  Deleted: 3,
};

export const ProxyType = {
  Individual: "Individual",
  Group: "Group",
};

export const RequestStatusType = {
  Pending: 1,
  Approved: 2,
  Rejected: 3,
  Expired: 4,
  Cancelled: 5,
  FirstPending: 6,
  SecondPending: 7,
};

export const AppInsightsMessage = {
  LoginSuccessful: 'User Login Successful',
  PreTripSuccessful: 'PreTrip Request Raised Successfully',
}

export const feedBackApiUrl = (): string => {
  if (window.location.href.includes("onesitepass")) {
    return "https://coetest01.azurewebsites.net/UserFeedbackAPI/api/checkUserForFeedback";
  } else {
    return "https://coeph001.es.slb.com/UserFeedbackAPI/api/checkUserForFeedback";
  }
};

export const feedBackPage = (): string => {
  if (window.location.href.includes("onesitepass")) {
    return (
      "https://slb001.sharepoint.com/sites/UserFeedback/SiteAssets/coeapp/index.aspx?AppID=" +
      feedBackAppId()
    );
  } else {
    return (
      "https://slb001.sharepoint.com/sites/UserFeedbackStaging/SiteAssets/coeapp/index.aspx?AppID=" +
      feedBackAppId()
    );
  }
};

export const feedBackAppId = (): string => {
  if (
    window.location.href.includes("localhost") ||
    window.location.href.includes("hseglobal-dev")
  ) {
    return "2726";
  } else if (window.location.href.includes("hseglobal-qa")) {
    return "2727";
  } else if (window.location.href.includes("hseglobal-uat")) {
    return "2728";
  } else {
    return "";
  }
};

export const NOT_AVAILABLE = "N.A.";
